// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__qaRnA","tip":"Tooltip_tip__edYt5","arrow":"Tooltip_arrow__POavq"};